import { render, staticRenderFns } from "./MhNotification.vue?vue&type=template&id=6664b4e3&"
import script from "./MhNotification.vue?vue&type=script&lang=js&"
export * from "./MhNotification.vue?vue&type=script&lang=js&"
import style0 from "./MhNotification.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports